import React from 'react';
import { brandIcons, styled } from '@hiver/hiver-ui-kit';

const Wrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

const Logo = styled(brandIcons.Logo)(() => ({
  height: '26px',
  width: '26px',
  color: '#FFFFFF',
  marginRight: '4px',
}));

const Message = styled('div')(() => ({
  padding: '5px 8px',
}));

const HiverIconToast = ({ message }) => (
  <Wrapper>
      <Logo />
      <Message>{message}</Message>
  </Wrapper>
);

export default HiverIconToast;